module.exports = __webpack_public_path__ + "img/传输设备.efcdfa00.gif";